import { ChangeDetectorRef, Component } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { ActionPlanService, ApplicationService } from '../../shared/services/index';
import { ReportPdfListPageComponent } from '../../shared/pages/index';

@Component({
    templateUrl: '../../shared/pages/report-list/report-pdf-list.component.html',
    standalone: false
})
export class ActionPlanReportPdfListPageComponent extends ReportPdfListPageComponent {
  public sendReport = false;

  constructor(
    public reportService: ActionPlanService,
    public applicationService: ApplicationService,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    location: Location,
    public cdf: ChangeDetectorRef
  ) {
    super(reportService, applicationService, router, activatedRoute, location, cdf);
  }

  goToBack(): void {
    this.router.navigate([this.actionPlansRoute]);
  }
}
